import { http } from '@/core/helpers/axiosHelper';
import { CANDIDATE_ENDPOINTS } from '@nxtpeople/nxt-styles';
import { LocationQuery } from 'vue-router';
import { Candidate } from './candidate.interface';

export class CandidateService {
   async getCandidates(query?: LocationQuery) {
      const response = await http.get<Array<Candidate>>(CANDIDATE_ENDPOINTS.GET_ALL(), { params: { ...query } });
      return response.data;
   }
   async getCandidate(syncId: string, query?: LocationQuery) {
      const response = await http.get<Candidate>(CANDIDATE_ENDPOINTS.GET(syncId), { params: { ...query } });
      return response.data;
   }
}
